<template>
  <div class="queryPay page-container">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('components.create_time') }}
              </div>
              <el-date-picker
                v-model="search.create_time"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item" :class="{'border-red':isShowBorderRed || isShowBorderInvoiceRed}">
              <div class="filter-item-label">
                {{ $t('merchantAccount.complete_time') }}
              </div>
              <el-date-picker
                v-model="search.complete_time"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('components.status') }}</div>
              <el-select v-model="search.status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in beneficiaryAuditMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="filter-item" />
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <el-button class="mb-10 download-btn" type="info" size="small" icon="el-icon-plus" @click="onClickAddtn">{{ $t('components.create') }}</el-button>
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column v-if="$store.getters.isPii" :label="$t('components.transaction_country')" align="center">
          <template slot-scope="scope">
            <span>{{ $store.getters.findOnlineCountryObj(scope.row.country_code).label }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('merchantAccount.beneficiary_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.disbursement_order }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('merchantAccount.beneficiary_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.disbursement_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.beneficiary_account_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.disbursement_number }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.short_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.disbursement_short_name }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="['TH', 'AE'].includes($store.getters.curCountry.country_code)" min-width="100" :label="$t('merchantAccount.beneficiary_account_type')" align="center">
          <template slot-scope="scope">
            <span>{{ beneficiaryAccountTypeFormat(scope.row.beneficiary_account_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="['TH', 'AE'].includes($store.getters.curCountry.country_code)" :label="$t('merchantAccount.beneficiary_type')" align="center">
          <template slot-scope="scope">
            <span>{{ beneficiaryTypeFormat(scope.row.beneficiary_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.receiving_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.disbursement_channel }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center" min-width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.status')" align="center" min-width="105">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="findBeneficiaryAuditMap(scope.row.status).type">     <span>{{ findBeneficiaryAuditMap(scope.row.status).label }}</span></el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.amount_limit')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.disbursement_payout_limit_amount === 2 || scope.row.contract_amount === null">/</span>
            <div v-else>{{ scope.row.contract_amount | toDivideWithDot }}</div>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="left" min-width="120px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
            >
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row)" />
            </el-tooltip>
            <el-tooltip
              placement="top"
            >
              <div slot="content">
                <span> {{ $t('components.delete') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-delete" @click="onClickDeleteBtn(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.status === ADUIT_STATUS['Returned']"
              placement="top"
            >
              <div slot="content">
                <span> {{ $t('components.edit') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-edit" @click="onClickEditBtn(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="$store.getters.isHasAuth('AUTH_CODE_LARGE_CREATE_DISBURSEMENT') && scope.row.status === ADUIT_STATUS['Approved'] && (scope.row.contract_amount > 0 || scope.row.disbursement_payout_limit_amount === 2)"
              placement="top"
            >
              <div slot="content">
                <span> {{ $t('components.create_payment') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-create-payment" @click="onClickCreatePaymentBtn(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-container">
      <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
    </div>
    <LargePayoutApprovalStepAddModal ref="LargePayoutApprovalStepAddModal" @updateList="getList" />
    <LargePayoutApprovalStepDetailModal ref="LargePayoutApprovalStepDetailModal" @updateList="getList" />
    <SinglePayoutCreateModal ref="singlePayoutCreateModal" @updateList="getList" />
    <LargePayoutApprovalStepAddUnlockModal ref="LargePayoutApprovalStepAddUnlockModal" @updateList="getList" />
  </div>
</template>

<script>

import { queryLargeValueBeneficiaryList, deleteLargeValueBeneficiary } from '@/api/online-transaction/online-transaction'
import { beneficiaryAuditMap } from '@/maps/status'
import SmoothSignature from 'smooth-signature'
export default {
  name: 'Customer_Service_Query_Pay',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    SinglePayoutCreateModal: () => import('./Modal/SinglePayoutCreateModal.vue'),
    LargePayoutApprovalStepAddModal: () => import('./Modal/LargePayoutApprovalStepAddModal.vue'),
    LargePayoutApprovalStepDetailModal: () => import('./Modal/LargePayoutApprovalStepDetailModal.vue'),
    LargePayoutApprovalStepAddUnlockModal: () => import('./Modal/LargePayoutApprovalStepAddUnlockModal.vue')
  },
  data() {
    this.ADUIT_STATUS = {
      Reviewing: 1,
      Approved: 2,
      Rejected: 3,
      Returned: 4,
      Expired: 5
    }

    this.timer = null
    return {
      isShowBorderRed: false,
      isShowBorderInvoiceRed: false,
      showFilterContent: true,
      search: {
        create_time: [],
        complete_time: []
      },
      tableData: [],
      payTypeArr: [], // 支付类型数组
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: 0
    }
  },
  computed: {
    beneficiaryAccountTypeFormat() {
      const obj = {
        'BANK': this.$t('map.beneficiary_account_type_0'),
        'PROMPTPAY': this.$t('map.beneficiary_account_type_1'),
        'EWALLET': this.$t('map.beneficiary_account_type_2')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    beneficiaryTypeFormat() {
      const obj = {
        'NATIONAL_ID': this.$t('map.beneficiary_type_0'),
        'MOBILE_NUMBER': this.$t('map.beneficiary_type_1'),
        'EWALLET_ID': this.$t('merchantAccount.account_type_ewallet_id')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    findBeneficiaryAuditMap() {
      return function(value) {
        return beneficiaryAuditMap(value)
      }
    },
    beneficiaryAuditMap() {
      return beneficiaryAuditMap()
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.signature = new SmoothSignature(this.$refs.canvas, {
      width: 300,
      height: 150,
      scale: 1,
      minWidth: 1,
      maxWidth: 3,
      color: '#0054F0',
      bgColor: '#efefef'
    })
  },
  methods: {
    onClickAddtn() {
      if (this.$store.getters.isPii) {
        this.$refs.LargePayoutApprovalStepAddModal.showModal()
      } else {
        this.$refs.LargePayoutApprovalStepAddUnlockModal.showModal()
      }
    },
    onClickEditBtn(row) {
      if (this.$store.getters.isPii) {
        this.$refs.LargePayoutApprovalStepAddModal.showModal(row)
      } else {
        this.$refs.LargePayoutApprovalStepAddUnlockModal.showModal(row)
      }
    },
    onClickDetailBtn(row) {
      if (this.$store.getters.isPii) {
        this.$refs.LargePayoutApprovalStepDetailModal.showModal(row)
      } else {
        this.$refs.LargePayoutApprovalStepAddUnlockModal.showModal(row, true)
      }
    },
    onClickCreatePaymentBtn(row) {
      this.$refs.singlePayoutCreateModal.showModal({ ...row, paymentType: 2 })
    },
    onClickDeleteBtn(row) {
      this.$confirm(this.$t('tips.delete_the_beneficiary'), this.$t('components.delete'), {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        deleteLargeValueBeneficiary({ id: row.id }).then(res => {
          this.$message.success('Success')
          this.confirm()
        })
      })
    },
    getParams(otherParams = {}) {
      const { create_time, complete_time = [], ...otherSearch } = this.search
      let params = { start_date_time: create_time && create_time[0], end_date_time: create_time && create_time[1],
        complete_start_date_time: complete_time && complete_time[0], complete_end_date_time: complete_time && complete_time[1],
        ...otherSearch, ...otherParams }

      params = this.$commonFn.filterEmptyAttr(params)
      return params
    },
    confirm() {
      const { limit } = this.listQuery
      const params = {
        page: this.listQuery.page,
        limit
      }
      this.getList(params)
    },

    onClickSearchBtn() {
      this.getList()
    },
    // 获取请求列表
    getList(otherParams = {}) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      queryLargeValueBeneficiaryList(params).then(res => {
        const { list, total } = res.data || {}
        this.tableData = list || []
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
      }).finally(() => {
        this.listLoading = false
        this.isShowBorderRed = false
      })
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>maps.js

<style lang="scss" scoped>
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.queryPay_popover_title{
  text-align: center;
  color: #606266;
}
.queryPay_textarea{
  margin-bottom: 20px;
}
.queryPay_btn-container{
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
}
.queryPay_size-btn{
  width: 80px;
  height: 28px;
  line-height: 6px;
}
.queryPay{
  margin: 20px;
  background: #fff;
  border-radius: 4px;
  .pagination-container{
    padding: 20px;
    margin-top: 0;
  }
  .filter-container{
    padding: 40px 0 24px 24px;
  }

  .search-frame {
    width: 256px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
  // .search-btn {
  //   margin-left: 10px;
  // }
  .tag-status{
    // text-decoration: underline;
    // cursor: pointer;
  }
}
.icon-layout{
  font-size: 16px;
  color: #98A1B4;
  margin: 10px;
  &:hover{
    color: #1A3465;
  }
}
</style>
